import type { Template } from "@/types";

export const PO_06_H3_V3: Template[] = [
    {
        id: "po-06-h3v3-01",
        name: "PO 01 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 45, y: 165, width: 235, height: 146, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 318, width: 235, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 45, y: 471, width: 235, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 287, y: 165, width: 321, height: 452, rotation: 0, imageRotation: 0 },
            { id: "5", x: 646, y: 195, width: 280, height: 393, rotation: 0, imageRotation: 0 },
            { id: "6", x: 933, y: 195, width: 280, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-02",
        name: "PO 02 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 45, y: 145, width: 373, height: 531, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 425, y: 145, width: 186, height: 262, rotation: 0, imageRotation: 0 },
            { id: "3", x: 425, y: 415, width: 186, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 701, y: 145, width: 565, height: 353, rotation: 0, imageRotation: 0 },
            { id: "5", x: 701, y: 505, width: 279, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 505, width: 279, height: 171, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-03",
        name: "PO 03 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 45, y: 145, width: 565, height: 353, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 45, y: 505, width: 279, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 505, width: 279, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 701, y: 145, width: 372, height: 531, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1081, y: 145, width: 186, height: 262, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1081, y: 415, width: 186, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-04",
        name: "PO 04 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 45, y: 127, width: 564, height: 352, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 486, width: 279, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 331, y: 486, width: 278, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 693, y: 170, width: 308, height: 443, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1009, y: 170, width: 156, height: 219, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1009, y: 396, width: 156, height: 217, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-05",
        name: "PO 05 - H3V3",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 53, y: 74, width: 327, height: 207, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 288, width: 327, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 501, width: 327, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 387, y: 74, width: 453, height: 633, rotation: 0, imageRotation: 0 },
            { id: "5", x: 975, y: 74, width: 221, height: 313, rotation: 0, imageRotation: 0 },
            { id: "6", x: 975, y: 394, width: 221, height: 313, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-06",
        name: "PO 06 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 63, y: 146, width: 402, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 395, width: 402, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 472, y: 146, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 472, y: 312, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 472, y: 478, width: 118, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 676, y: 227, width: 527, height: 329, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-07",
        name: "PO 07 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 800, y: 153, width: 368, height: 514, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 153, width: 273, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 153, width: 272, height: 392, rotation: 0, imageRotation: 0 },
            { id: "4", x: 66, y: 552, width: 179, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 253, y: 552, width: 179, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 440, y: 552, width: 179, height: 114, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-08",
        name: "PO 08 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 44, y: 184, width: 334, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 386, y: 184, width: 333, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 727, y: 184, width: 333, height: 450, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1068, y: 184, width: 200, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 337, width: 200, height: 145, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 490, width: 200, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-09",
        name: "PO 09 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 47, y: 224, width: 116, height: 164, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 394, width: 261, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 170, y: 224, width: 261, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 315, y: 394, width: 116, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 438, y: 224, width: 530, height: 334, rotation: 0, imageRotation: 0 },
            { id: "6", x: 976, y: 224, width: 230, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-10",
        name: "PO 10 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 213, width: 128, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 395, width: 128, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 135, y: 213, width: 569, height: 357, rotation: 0, imageRotation: 0 },
            { id: "4", x: 711, y: 213, width: 260, height: 357, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 213, width: 273, height: 175, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 395, width: 273, height: 175, rotation: 0, imageRotation: 0 }
        ],
    }
];